import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-refine",
  "use": "icon-refine-usage",
  "viewBox": "0 0 48.54 40.87",
  "content": "<symbol viewBox=\"0 0 48.54 40.87\" id=\"icon-refine\">\r\n    <title>refine</title>\r\n    <path d=\"M39.26.43h4.87V41.29H39.26Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M41.7,19.66a7.2,7.2,0,1,1-7.3,7.2A7.25,7.25,0,0,1,41.7,19.66Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M22.27.43h4.87V41.29H22.27Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M24.73,5.26a7.2,7.2,0,1,1-7.27,7.2A7.23,7.23,0,0,1,24.73,5.26Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M5.28.43h4.87V41.29H5.28Z\" transform=\"translate(-0.46 -0.43)\" /><path d=\"M7.73,26.89a7.2,7.2,0,1,1-7.27,7.2A7.23,7.23,0,0,1,7.73,26.89Z\" transform=\"translate(-0.46 -0.43)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/refine.svg
// module id = ./app/general/svg/refine.svg
// module chunks = app